import { defineMessages } from "react-intl";

const messages = defineMessages({
    emptyTest: {
        id: "test.emptyTask",
    },
    noPreview: {
        id: "test.extra.no.preview",
    },
    newTask: {
        id: "test.newTask",
    },
    generateTasks: {
        id: "test.generateTask",
    },
});

export default messages;
